module.exports = __webpack_public_path__ + "img/no_filtered_housemates.6a29c7b5.svg";